<template>
  <div class="position-relative w-100">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      :state="state"
      v-model="query"
      placeholder="Выберите заявку"
      autocomplete="off"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
      <v-icon v-if="query" name="buttons/cross" :size="11"/>
      <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
      <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
    </button>

    <div v-if="isFocus" class="custom-dropdown-select">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="onSelect(item)"
        >
          <div class="text-small">#{{ item.id }}</div>
          <div class="text-secondary text-small">{{ item.location_vacancy_name }}</div>
        </div>
      </div>

      <div v-if="filteredItems.length === 0 && query" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
      </div>
    </div>
  </div>
</template>

<script>
import recruitTasks from "../../network/recruitTasks";

export default {
  name: "RecruitTaskSelect",
  mixins: [ recruitTasks ],
  props: {
    isDisabled: { type: Boolean, default: false },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isFocus: false,
      query: '',
      items: [],
      selectedItem: null
    }
  },
  mounted() {
    this.getItems();
  },
  computed: {
    filteredItems() {
      const query = this.query ? this.query.trim().toLowerCase() : '';

      if (!query) return this.items;

      if (this.selectedItem && String(this.selectedItem.id) === query) {
        return this.items;
      }

      return this.items.filter(item => (
        item.location_vacancy_name.toLowerCase().includes(query) ||
        String(item.id).includes(query)
      ));
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.query = String(newValue);
          this.selectedItem = this.items.find(i => i.id === newValue) || null;
        } else {
          this.query = '';
          this.selectedItem = null;
        }
      }, immediate: true
    },
    items(newValue) {
      if (this.value && !this.selectedItem) {
        this.selectedItem = newValue.find(i => i.id === this.value) || null;
      }
    }
  },
  methods: {
    async getItems() {
      const result = await this.getRecruitTasks({});
      this.items = (result && result.data) ? result.data.items : [];
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.selectedItem) {
        this.query = String(this.selectedItem.id);
      } else {
        this.query = '';
      }
    },
    onClick() {
      if (this.query) {
        this.onClear();
        this.$refs.input_ref.$el.focus();
      } else {
        this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    onSelect(item) {
      this.query = String(item.id);
      this.selectedItem = item;
      this.$emit('onSelect', item.id);
      this.onFocusOut();
    },
    onClear() {
      this.query = '';
      this.selectedItem = null;
      this.$emit('onSelect', 0);
      this.$emit('onClear');
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Recruiting/RecruitTaskSelect.vue